function initialState() {
  return {
    isLoadingCount: 0,
  };
}

const state = initialState;

const getters = {
  getIsLoading: (state) => state.isLoadingCount > 0,
};

const mutations = {
  setIsLoading: (state, data) => {
    if (data) {
      state.isLoadingCount += 1;
    } else {
      state.isLoadingCount -= 1;
    }
  },
};

const actions = {
  SET_IS_LOADING_DATA: ({ commit }, data) => {
    commit("setIsLoading", data);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
